import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { UserHelper } from 'src/app/providers/helpers/user-helper.service';
import { VERSION } from 'src/assets/constants/version';

@Injectable()
export class ExportHelper {
  constructor(private readonly userHelper: UserHelper) {}

  /**
   * Exports the given Object as a JSON-File to download
   * @param obj Object to export
   * @param removeIds remove ids from the object before the export?
   */
  exportJson(
    obj: any,
    type: string,
    removeIds: boolean = true,
    removeAdditionalParams?: string[]
  ): void {
    const removeParams = ['id', 'created_at', 'updated_at'].concat(
      removeAdditionalParams || []
    );
    obj = JSON.parse(JSON.stringify(obj));
    obj.exportObjectType = type;
    obj.exportVersion = VERSION;
    if (removeIds) this.removeParams(obj, removeParams);
    const blob = new Blob([JSON.stringify(obj, null, 2)], {
      type: 'application/json',
    });
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    const fileName = obj.name.replace(/\s/g, '_').toLowerCase();
    a.download = fileName + '-export.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  /**
   * Exports the given Object as a JSON-File to download
   * @param obj Object to export
   * @param removeIds remove ids from the object before the export?
   */
  exportText(data: any, title: string, description: string = ''): void {
    const obj = {
      data: JSON.parse(JSON.stringify(data)),
      appVersion: VERSION,
      user: this.userHelper.getUser(true),
      date: new Date().toISOString(),
    };

    const blob = new Blob([JSON.stringify(obj, null, 2)], {
      type: 'text/plain',
    });
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    const fileName = title.replace(/\s/g, '_').toLowerCase();
    a.download = fileName + '-export.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  /**
   * removes the given params from the given object
   * @param obj Object to remove the params from
   * @param rmParams Params to remove
   */
  private removeParams(obj: any, rmParams: string[] = ['id']): void {
    if (obj && typeof obj === 'object') {
      if (Array.isArray(obj)) {
        obj.forEach((item) => this.removeParams(item, rmParams));
      } else {
        Object.keys(obj).forEach((key) => {
          if (rmParams.includes(key)) {
            delete obj[key];
          } else {
            this.removeParams(obj[key], rmParams);
          }
        });
      }
    }
  }
}
